import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import EmailVerificationPrompt from './EmailVerificationPrompt';
import { t } from '../i18n';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>{t('loading')}</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // If user is not email verified, show verification prompt instead of content
  if (!user.is_email_verified) {
    return <EmailVerificationPrompt />;
  }

  return children;
};

export default PrivateRoute;